import {getUid} from "./components/use-cookie";

type endpoint = 'claps' | 'views';

interface DataModel {
    slug: string;
    recaptcha: string;
    target: endpoint;
    amount?: number;
    uid?: string;
}

export interface CounterFallbacks {
    views: number;
    claps: number;
    comments: number;
}

// Specify where we will request to
const gateway_url = 'https://uv87ctnza8.execute-api.eu-west-1.amazonaws.com/v2/visit';

// Specify the API key that will identify our interaction
const api_key = process.env.AWS_INTERACTION_API_KEY;


export const sendPayload = async (data: DataModel): Promise<void> => {
    if (!api_key) {
        console.error("API key is missing");
        return; // Or handle the missing API key case accordingly
    }

    try {
        // console.log(api_key)
        const response = await fetch(gateway_url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'X-Api-Key': api_key,
                'Content-Type': 'application/json'
            },
        });
        if (!response.ok) {
            // Handle non-ok response here
            console.error('Network response was not ok');
            return; // Exit function early or handle accordingly
        }

        // If you need to use the response text-data, you can do so here
        // const responseData = await response.json();
        // console.log(responseData);
    } catch (error) {
        // Handle errors here
        console.error('Error:', error);
    }
};


export const incrementClap = async (slug: string, token: string, amount: number) => {
    const safe_slug = slug.replace(/\//g, '')
    const data = {
        'slug': safe_slug,
        'recaptcha': token,
        'target': 'claps' as endpoint,
        'amount': amount
    }
    // specify the payload
    await sendPayload(data)
};


export const incrementView = async (slug: string, token: string) => {
    const safe_slug = slug.replace(/\//g, '')
    const uid = getUid()
    const data = {
        'slug': safe_slug,
        'recaptcha': token,
        'target': 'views' as endpoint,
        'uid': uid
    }
    await sendPayload(data)
};


export const fetchCounterData = async (slug: string, endpoint: string = 'views'): Promise<number> => {
    try {
        const url = `https://meta.maartenpoirot.com${slug}${endpoint}`
        const response = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
        });
        if (response.status === 404) {
            return 0;
        } else if (response.ok) {
            const num = await response.text();
            return parseInt(num)
        } else {
            return 0
        }
    } catch (error) {
        return 0
    }
};



// export const fetchComments = async (slug: string, endpoint: string = 'comments'): Promise<Array<CommentProps>> => {
//     try {
//         const url = `https://meta.maartenpoirot.com${slug}0000`
//         const response = await fetch(url, {
//             method: 'GET',
//             mode: 'cors',
//             cache: 'no-cache',
//         });
//         if (response.status === 404) {
//             return 0;
//         } else if (response.ok) {
//             const num = await response.text();
//             return parseInt(num)
//         } else {
//             return 0
//         }
//     } catch (error) {
//         return 0
//     }
// };


//
//
// export const incrementView = async (slug: string, token: string) => {
//     const safe_slug = slug.replace(/\//g, '')
//
//     // Get the user UID, create a new one if needed
//     const uid = getUid()
//
//     // specify the payload
//     const text-data = {
//         'slug': safe_slug,
//         'recaptcha': token,
//         'target': 'views',
//         'uid': uid
//     };
//
//     if (!api_key) {
//         console.error("API key is missing");
//         return; // Or handle the missing API key case accordingly
//     }
//
//     try {
//         const response = await fetch(gateway_url, {
//             method: 'POST',
//             body: JSON.stringify(text-data),
//             headers: {
//                 'X-Api-Key': api_key,
//                 'Content-Type': 'application/json'
//             },
//         });
//
//         if (!response.ok) {
//             // Handle non-ok response here
//             console.error('Network response was not ok');
//             return; // Exit function early or handle accordingly
//         }
//
//         // If you need to use the response text-data, you can do so here
//         // const responseData = await response.json();
//         // console.log(responseData);
//     } catch (error) {
//         // Handle errors here
//         console.error('Error:', error);
//     }
// };